import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import enUS from '@/languages/en-US.json';
import oodleUS from '@/languages/oodle-US.json';
import Cookies from 'js-cookie';

const SUPPORTED_LANGUAGES = ['en-US'];

const resources = {
  'en-US': { translation: enUS },
} as Resource;

if (!Cookies.get('language') || navigator.languages) {
  const language = navigator.languages[0];
  if (SUPPORTED_LANGUAGES.includes(language)) {
    Cookies.set('language', language);
  } else {
    Cookies.set('language', 'en-US');
  }
}

const language = Cookies.get('language') ?? 'en-US';

i18n.use(initReactI18next).init({
  resources,
  lng: language,
  debug: true,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
